const validScenes = [
    'landing',
    'intro',
    'technology',
    'strategy',
    'culture',
    'prototype',
    'empowerment',
    'innovation',
    'overview'
]

const sceneMap = new Map()

validScenes.forEach((s, i) => sceneMap.set(s, i))

const getNextScene = scene => {
    if (!sceneMap.has(scene)) return null

    let i = sceneMap.get(scene)
    return validScenes[i < validScenes.length - 1 ? (i += 1) : i]
}

const getPreviousScene = scene => {
    if (!sceneMap.has(scene)) return null

    // don't allow to go back to landing
    let i = sceneMap.get(scene)
    return validScenes[i > 1 ? (i -= 1) : i]
}

export {
    validScenes,
    sceneMap,
    getNextScene,
    getPreviousScene,
    fillMap,
    scrollMap,
    sceneData
}

const fillMap = new Map([
    ['landing', 0],
    ['intro', 0],
    ['technology', 0.2],
    ['strategy', 0.2],
    ['culture', 0.2],
    ['prototype', 0.4],
    ['empowerment', 0.4],
    ['innovation', 0.4],
    ['overview', 0.6]
])

const scrollMap = new Map([
    ['landing', 0],
    ['intro', 0.1],
    ['technology', 0.5],
    ['strategy', 0.5],
    ['culture', 0.5],
    ['prototype', 0.5],
    ['empowerment', 0.5],
    ['innovation', 0.5],
    ['overview', 0.5]
])

const sceneData = {
    intro: {
        scrollProgress: [0, 0.3],
        index: 0
    },
    technology: {
        scrollProgress: [0.3, 0.4],
        index: 1
    },
    strategy: {
        scrollProgress: [0.4, 0.5],
        index: 2
    },
    culture: {
        scrollProgress: [0.5, 0.6],
        index: 3
    },
    prototype: {
        scrollProgress: [0.6, 0.7],
        index: 4
    },
    empowerment: {
        scrollProgress: [0.7, 0.8],
        index: 5
    },
    innovation: {
        scrollProgress: [0.8, 0.9],
        index: 6
    },
    overview: {
        scrollProgress: [0.9, 1],
        index: 7
    }
}
